import React from 'react';
import PropTypes from 'prop-types';

import { NotificationManager, useLabel } from '@atlas/core';
import { ChipsItem } from '@atlas/ui';

const RealityCheckButton = ({ period, selectedPeriod = null, setSelectedPeriod, text }) => {
  const timeLabel = useLabel(text);

  const onClick = () => {
    if (period === selectedPeriod) {
      return;
    }
    setSelectedPeriod(period);
    if (period === 'NEVER') {
      NotificationManager.notify({
        message: 'reality_check_period_notification_disabled',
        status: 'success',
        type: 'notification',
      });
    } else {
      NotificationManager.notify({
        data: { period: timeLabel },
        message: 'reality_check_period_notification',
        status: 'success',
        type: 'notification',
      });
    }
  };

  return <ChipsItem active={selectedPeriod === period} label={timeLabel} onClick={onClick} />;
};

RealityCheckButton.propTypes = {
  period: PropTypes.string.isRequired,
  selectedPeriod: PropTypes.string.isRequired,
  setSelectedPeriod: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default RealityCheckButton;
